import { useEffect } from 'react'

import { LIVE_HEARTBEAT_INTERVAL, LIVE_TRACK_EVENT, trackLiveEvent } from '@/methods/liveTracking'

// 觀看心跳：在直播間、頁面在前景時每 60 秒送一次，後台用來算觀看分鐘、有效觀看（滿 1 分鐘）與回放觀看
const useLiveWatchHeartbeat = ({ roomId, enabled }: { roomId?: string; enabled: boolean }) => {
  useEffect(() => {
    if (!enabled || !roomId) return

    const timer = setInterval(() => {
      if (document.visibilityState === 'visible') {
        trackLiveEvent({ type: LIVE_TRACK_EVENT.HEARTBEAT, roomId })
      }
    }, LIVE_HEARTBEAT_INTERVAL)

    return () => clearInterval(timer)
  }, [roomId, enabled])
}

export default useLiveWatchHeartbeat
